import type { ReactElement } from 'react';

import { ConfigurationCriteriaIdsEnum } from 'src/features/configuration/configurationCriteria/enums/ConfigurationCriteriaIdsEnum';
import { cn } from 'src/lib/utils';

type ConfigurationCriterionBadgeProps = {
  id: string;
  className?: string;
};

export function ConfigurationCriterionBadge({
  id,
  className,
}: ConfigurationCriterionBadgeProps): ReactElement {
  const getBadgeColor = (id: string) => {
    switch (id) {
      case ConfigurationCriteriaIdsEnum.top:
        return 'bg-rose-300 border border-rose-400 dark:bg-rose-700 dark:border-rose-600';
      case ConfigurationCriteriaIdsEnum.bestsellers:
        return 'bg-purple-300 border border-purple-400 dark:bg-purple-700 dark:border-purple-600';
      case ConfigurationCriteriaIdsEnum['smape-last-months']:
        return 'bg-blue-300 border border-blue-400 dark:bg-blue-700 dark:border-blue-600';
      case ConfigurationCriteriaIdsEnum['first-stocking-last-months']:
        return 'bg-teal-300 border border-teal-400 dark:bg-teal-700 dark:border-teal-600';
      case ConfigurationCriteriaIdsEnum['sales-deviation-forecast']:
        return 'bg-lime-300 border border-lime-400 dark:bg-lime-700 dark:border-lime-600';
      case ConfigurationCriteriaIdsEnum['forecast-not-validated-since']:
        return 'bg-orange-300 border border-orange-400 dark:bg-orange-700 dark:border-orange-600';
      case ConfigurationCriteriaIdsEnum['tracking-signal']:
        return 'bg-rose-300 border border-rose-400 dark:bg-rose-700 dark:border-rose-600';
      case ConfigurationCriteriaIdsEnum['destocking-last-days']:
        return 'bg-yellow-300 border border-yellow-400 dark:bg-yellow-700 dark:border-yellow-600';
      default:
        return 'bg-gray-300 border border-gray-400 dark:bg-gray-700 dark:border-gray-600';
    }
  };

  return (
    <div
      className={cn(
        'size-2 rounded-full font-semibold text-xs',
        getBadgeColor(id),
        className,
      )}
    />
  );
}
